import { Typography } from '@/components/Typography/Typography';
import { RequestTypeType, VendorVaultCatalogType } from '@/types/vendorVaultTypes';
import { OptionCard, OptionGrid } from '@/bundle/_OrgAdmin/pages/MyVaultPage/styles';

type RequestTypeCardsType = {
  catalog: VendorVaultCatalogType;
  counts: Partial<Record<RequestTypeType, number>>;
  value: RequestTypeType;
  onChange: (value: RequestTypeType) => void;
};

export const RequestTypeCards = ({ catalog, counts, value, onChange }: RequestTypeCardsType) => (
  <OptionGrid $cols={3}>
    {(Object.keys(catalog.request_types) as RequestTypeType[]).map((code) => {
      const meta = catalog.request_types[code];

      return (
        <OptionCard key={code} type='button' $active={value === code} onClick={() => onChange(code)}>
          <Typography fontWeight='semibold'>{meta.label}</Typography>
          <Typography variant='bodySmall'>{meta.summary}</Typography>
          <Typography variant='caption'>{counts[code] ?? 0} requests</Typography>
        </OptionCard>
      );
    })}
  </OptionGrid>
);
